export const urlConfig={
    baseApiUrl:process.env.REACT_APP_API_URL,
    baseUrl:process.env.REACT_APP_BASE_URL,
    imageBaseUrl:process.env.REACT_APP_IMAGE_BASE_URL,
}